import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";
import { userSchema } from "../user";
import { registerSchema } from "./register";

export const bulkRegisterSchema = z.object({
  users: z.array(registerSchema).min(1),
});

export class BulkRegisterDto extends createZodDto(bulkRegisterSchema) {}

export const bulkRegisterResultSchema = z.object({
  success: z.boolean(),
  email: z.string().email(),
  user: userSchema.optional(),
  error: z.string().optional(),
});
